import React from 'react'
import { Text, VStack } from '@chakra-ui/react'
import { Layout } from '../../components'

const Privacy = () => {
  return (
    <Layout noMb title="Privacy Policy">
      <VStack pb="3rem" align="flex-start" spacing="2rem" fontSize="1.2rem" lineHeight="2rem">
        <Text color="brand.blue" textTransform="uppercase">
          {' '}
          1. About Kappa
        </Text>
        <Text mt="0 !important">Kappa is an insurance marketplace.</Text>
        <Text>
          The aim of this privacy policy is to provide our customers with an explanation of how our
          organisation uses the personal data we receive from our customers and related partners
          when you use our website, applications or subscribe to use any of our products and
          services. This Privacy Policy is our policy regarding the privacy of personal information
          we collect online in connection with our business services and you agree that we may use
          any information you provide in accordance with this Privacy Policy.
        </Text>
        <Text color="brand.blue" textTransform="uppercase">
          2. Introduction
        </Text>
        <Text mt="0 !important">
          This privacy policy applies to the Kappa website. In this Privacy Policy, “we”, “us” or
          “our” refers to Kappa and its successors in title, agents and assigns, while “you”, “your”
          refers to you and/or any person who subscribes for, uses or authorises the use of our
          Services.
        </Text>
        <Text>
          Kappa conducts business in a responsible and sustainable manner, maintaining the highest
          level of industry standards thereby ensuring the security of customer information
          collected, processed and stored based on business requirements. Kappa’s services by users
          and identifies the purposes for which personal information is collected, used, processed,
          disclosed, retained and disposed of.
        </Text>
        <Text>
          We state that we do not consider personal information to include information that has been
          made anonymous so that it does not identify a specific user.
        </Text>
        <Text color="brand.blue" textTransform="uppercase">
          3. Privacy Policy
        </Text>
        <Text color="brand.blue" mt="0 !important">
          3.1. Consent
        </Text>
        <Text mt="0 !important">
          As a Customer of Kappa, you accept this Privacy Policy when you sign up for, access, or
          use our products, services, content, features, technologies or functions offered on our
          website and all related sites and services (collectively referred to as “Kappa Services”).
        </Text>
        <Text color="brand.blue">3.2. Collecting Personal Information</Text>
        <Text mt="0 !important">
          We collect your personal information otherwise known as Personally Identifiable
          Information (PII). They include Name, email address, phone number, contact address,
          limited financial information, location data, device data, etc. This information may be
          collected automatically, via third party sources or as provided by you.
        </Text>
        <Text color="brand.blue">3.3. Information We Collect</Text>
        <Text mt="0 !important">
          The information that we collect will depend on our relationship with you. Where other
          people are named on your policy, we may ask you to provide the information below in
          relation to those people too, if this is relevant to your insurance.
        </Text>
        <Text>We collect the following details about you</Text>
        <Text>
          Personal Data contact details such as name, email address, home/office address and
          telephone number
        </Text>
        <Text>
          Details of any other persons included on the policy where they are named on your policy
          and the relationship to you as policyholder;
        </Text>
        <Text>
          Identification information such as your date of birth, national identity number, Bank
          verification number including other identification number from your passport, driving
          license and other valid means of identification;
        </Text>
        <Text>Financial information such as bank details;</Text>
        <Text>
          Information relevant to your insurance policy such as details about your vehicle,
          property, previous policies or claims, recent damage, information about your travel plans,
          destination, planned activities and dates of travel;
        </Text>
        <Text>
          Information relevant to your claim or your involvement in the matter giving rise to a
          claim;
        </Text>
        <Text>Information about the nature of your business and commercial assets;</Text>
        <Text>
          Information obtained through our use of cookies. You can find out more about this in our
          cookies policy;
        </Text>
        <Text>Your marketing preferences;</Text>
        <Text>Sensitive Personal Data;</Text>
        <Text>Details of your current or former physical or mental health;</Text>
        <Text>
          Details concerning sexual life or sexual orientation, for example marital status
        </Text>
        <Text color="brand.blue">3.4. Privacy Of Children</Text>
        <Text mt="0 !important">
          We respect the privacy of children. We do not knowingly collect names, email addresses or
          any other Personal Data from children except where this is required to register them as
          beneficiaries in relation to a policy or other products. We do not knowingly market to
          children nor do we allow children under 18 to purchase any of our products or services.
        </Text>
        <Text color="brand.blue">3.5. Automatic Information </Text>
        <Text mt="0 !important">
          When you make use of our services, we or our authorised agent may collect information sent
          to us by your computer, mobile phone or other access device. This information includes but
          not limited to the following:
        </Text>
        <Text>Computer IP address;</Text>
        <Text>Device ID or unique identifier;</Text>
        <Text>Device type;</Text>
        <Text>Location;</Text>
        <Text>Computer connection and information;</Text>
        <Text>Mobile network provider;</Text>
        <Text>Anonymous information collected through cookies and web beacons.</Text>
        <Text color="brand.blue">3.6. How Personal Information Is Collected</Text>
        <Text mt="0 !important">
          Customer personal information is collected electronically, manually and automatically when
          customers visit our website and register for use of any of our products and services.
          Information is collected electronically during exchanges between your system (computer,
          mobile device and other electronic means of communication) and our system.
        </Text>
        <Text>
          Customers may also provide us personal information stored with third parties such as
          social media networks (for example: Facebook, WhatsApp, Twitter, et cetera). This
          information is controlled by the site and authorising us to have access to this
          information, grants Kappa the right to store or use such information in accordance with
          our privacy policy.
        </Text>
        <Text>
          Kappa also offers you the ability to connect with our Products and Services using a mobile
          device, either through a Mobile Application (app) or via a Mobile Optimised Website. The
          provisions of this Privacy Policy apply to all such mobile devices and access through such
          mediums.
        </Text>
        <Text color="brand.blue">3.7. Use Of Collected Information</Text>
        <Text mt="0 !important">
          Below are the reasons why we process your Personal Data and the applicable circumstances
          when we will do so:
        </Text>
        <Text>
          Processing is necessary in order for us to provide your insurance policy and services,
          such as assessing your application and setting you up as a policyholder, beneficiary,
          administering and managing your insurance policy or benefits, providing all related
          services, providing a quote, handling and paying claims and communicating with you. In
          these circumstances, if you do not provide such information, we will be unable to offer
          you a policy or process your claim.
        </Text>
        <Text>
          We may use Cloud storage solutions within or outside Nigeria which are chosen to ensure
          efficiency and improved performance through up to date technology.
        </Text>
        <Text>
          Where we have a legal or regulatory obligation to use such Personal Data , for example,
          when our regulators such as the National Insurance Commission (NAICOM), the National
          Health Insurance Scheme (NHIS), and our data protection regulator, the National
          Information Technology Development Agency (NITDA) wish us to maintain certain records of
          any dealings with you.
        </Text>
        <Text>
          To comply with: local or foreign laws, regulations, voluntary codes, directives,
          judgements or court orders, agreements between Kappa and any authority, regulator, or
          enforcement agency, good practice, government sanctions or embargoes, reporting
          requirements under financial transactions legislation and demands or requests of any
          authority, regulator, tribunal, enforcement agencies including but not limited to the
          Nigerian Financial Intelligence Unit (NFIU) and the Economic and Financial Crimes
          Commission (EFCC), or exchange bodies;
        </Text>
        <Text>
          Where we need to use your Personal Data to establish, exercise or defend our legal rights,
          for example when we are faced with any legal claims or where we want to pursue any legal
          claims ourselves;
        </Text>
        <Text>
          Where we need to use your Personal Data for reasons of substantial public interest, such
          as investigating fraudulent claims and carrying out fraud, credit and anti-money
          laundering checks, identification checks;
        </Text>
        <Text>Where we need to communicate with you to resolve complaints or other issues;</Text>
        <Text>
          Where we have a specific legal exemption to process sensitive Personal Data for insurance
          purposes. This exemption applies where we need to process your Personal Data as an
          essential part of the insurance cover, for example health data.
        </Text>
        <Text>
          Where you have provided your consent to our use of your Personal Data. We will usually
          only ask for your consent in relation to processing your sensitive Personal Data (such as
          health data) or when providing marketing information to you (including information about
          other products and services). This will be made clear when you provide your Personal Data.
          If we ask for your consent, we will explain why it is necessary. Without your consent in
          some circumstances, we may not be able to provide you with cover under the policy or
          handle claims or you may not be able to benefit from some of our services. Where you
          provide sensitive Personal Data about a third party, we may ask you to confirm and provide
          proof that the third party has provided his or her consent for you to act on their behalf;
        </Text>
        <Text>
          Where we have appropriate legitimate business need to use your Personal Data such as
          maintaining our business records, developing and improving our products and services, all
          whilst ensuring that such business need does not interfere with your rights and freedoms
          and does not cause you any harm.
        </Text>
        <Text>
          Where we need to use your Sensitive Personal Data such as health data because it is
          necessary for your vital interests, this being a life or death matter.
        </Text>
        <Text color="brand.blue" textTransform="capitalize">
          3.8. Protection And Storage Of Information
        </Text>
        <Text mt="0 !important">
          Information obtained from our customers are protected utilising encryption security
          standards to ensure the transmission of data to or from you by any means.
        </Text>
        <Text>
          ustomer information is processed and stored on our computers in Lagos, Nigeria and
          anywhere else where our facilities are located. We protect your information using
          physical, technical, and administrative security measures to reduce the risks of loss,
          misuse, unauthorised access, disclosure, and alteration.
        </Text>
        <Text>
          Some of the safeguards used by Kappa are firewalls and data encryption, physical access
          controls to our data centres, and information access authorisation controls. We have also
          taken additional measures by ensuring our system complies with industry information
          security standards.
        </Text>
        <Text>
          We take reasonable precautions to protect your information from loss, misuse or
          alteration. All of our employees, agents and contractors who have access to personal
          information are required to protect the confidentiality of this information in a manner
          consistent with this Privacy Policy. You should recognise, however, that there is no such
          thing as “perfect security” on the internet and we cannot guarantee the security of your
          Information. We cannot be liable for any breach of our systems or interception of our
          transmission and we hereby fully disclaim, to the fullest extent provided under law, any
          liability associated with any claim relating to a breach of security, data or information.
        </Text>
        <Text color="brand.blue">3.9. Cross Border Transfer Of Customer Information </Text>
        <Text mt="0 !important">
          We are committed to adequately protect all customer personal information regardless of
          where the data resides and to providing appropriate data protection measures for your
          personal information where such information is transferred across borders, including
          outside of Nigeria. Transfer of Information to Third Parties Upon a Sale or Change of
          Control. We retain the right to transfer or assign all information pursuant to a merger,
          purchase or other transaction relating to our Company, its affiliates and sponsors.
        </Text>
        <Text color="brand.blue">3.10. Marketing </Text>
        <Text mt="0 !important">
          The personal information of our Customers is our greatest concern as such we shall not
          sell or rent your personal information to third parties for their marketing purposes
          without your explicit consent. We may combine your information with information we collect
          from other companies and use it to improve and personalise Kappa’s Services, content, and
          advertising.
        </Text>
        <Text color="brand.blue">3.11. Cookies And Other Similar Technologies </Text>
        <Text mt="0 !important">
          We may place small data files on your computer or devices when you access our websites or
          use any of our services. These data files may be cookies, pixel tags, “Flash cookies”, or
          other local storage provided by your browser or associated applications (collectively
          referred to as “Cookies”). These technologies are used to recognise users as customers;
          customise our services, content, and advertising; measure promotional effectiveness; help
          ensure that account security is not compromised; mitigate risk and prevent fraud; and to
          promote trust and safety across Kappa Services and related sites.
        </Text>
        <Text>
          You are at liberty to decline our Cookies if the web browser or browser add-on permits
          unless our Cookies are required to prevent fraud or ensure the security of websites we
          control; However, declining our Cookies may interfere with users’ use of our websites and
          services.
        </Text>
        <Text color="brand.blue" textTransform="uppercase">
          4. Changes in Our Privacy Policy{' '}
        </Text>
        <Text mt="0 !important">
          We review our privacy policy periodically and when there is any substantial change to
          business or regulatory requirements. At the minimum, we shall review this annually and
          communicate via our communication channels such as Newsletter, on Website, Social Media
          Accounts.
        </Text>
        <Text color="brand.blue" textTransform="uppercase">
          5. How to Contact Us{' '}
        </Text>
        <Text mt="0 !important">
          Customers who have concerns, questions about the privacy policy or would like to exercise
          their protection rights can contact us through the following channels:
        </Text>
        <Text>
          Email us at:{' '}
          <Text color="brand.blue" as="a" href="mailto:info@trium.ng" fontWeight="500">
            {' '}
            info@trium.ng
          </Text>
        </Text>
      </VStack>
    </Layout>
  )
}

export { Privacy }
